import type { ReactNode } from "react";
import { Rows3 } from "lucide-react";

import styles from "./integrations.module.css";

const TONE: Record<"warning" | "danger" | "info" | "neutral", string> = {
  warning: styles.answerWarning,
  danger: styles.answerDanger,
  info: styles.answerInfo,
  neutral: "",
};

/** One thing waiting for a person: the problem, the rows it affects, and its fix under a rule. */
export function AnswerCard({
  title,
  tone = "warning",
  icon,
  meta,
  rows,
  children,
  actions,
}: {
  title: ReactNode;
  tone?: "warning" | "danger" | "info" | "neutral";
  icon?: ReactNode;
  meta?: ReactNode;
  /** How many rows the problem touches, when that is known. */
  rows?: number;
  children?: ReactNode;
  actions?: ReactNode;
}) {
  return (
    <article className={`${styles.answer} ${TONE[tone]}`}>
      <div className={styles.answerHead}>
        {icon && <span className={styles.answerIcon}>{icon}</span>}
        <div className={styles.answerTitleBox}>
          <span className={styles.answerTitle}>{title}</span>
          {(meta || rows !== undefined) && (
            <span className={styles.answerMeta}>
              {rows !== undefined && (
                <span className={styles.answerRows}>
                  <Rows3 size={12} aria-hidden />
                  Affects {rows.toLocaleString()} {rows === 1 ? "row" : "rows"}
                </span>
              )}
              {meta && <span>{meta}</span>}
            </span>
          )}
        </div>
      </div>
      {children && <div className={styles.answerBody}>{children}</div>}
      {actions && <div className={`${styles.actions} ${styles.answerActions}`}>{actions}</div>}
    </article>
  );
}
